var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.743 12.3321L12.743 2.33213C12.364 1.91013 11.636 1.91013 11.257 2.33213L2.25698 12.3321C2.12744 12.4757 2.04241 12.6539 2.01223 12.8449C1.98205 13.0359 2.00802 13.2316 2.08698 13.4081C2.24698 13.7691 2.60498 14.0011 2.99998 14.0011H4.99998V21.0011C4.99998 21.2663 5.10534 21.5207 5.29288 21.7082C5.48041 21.8958 5.73477 22.0011 5.99998 22.0011H8.99998C9.2652 22.0011 9.51955 21.8958 9.70709 21.7082C9.89463 21.5207 9.99998 21.2663 9.99998 21.0011V17.0011H14V21.0011C14 21.2663 14.1053 21.5207 14.2929 21.7082C14.4804 21.8958 14.7348 22.0011 15 22.0011H18C18.2652 22.0011 18.5196 21.8958 18.7071 21.7082C18.8946 21.5207 19 21.2663 19 21.0011V14.0011H21C21.1937 14.002 21.3834 13.9464 21.546 13.8413C21.7087 13.7361 21.8372 13.5859 21.916 13.409C21.9947 13.2321 22.0203 13.0361 21.9896 12.8448C21.9589 12.6536 21.8732 12.4755 21.743 12.3321Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home-white.b04382d5.svg";
export { ForwardRef as ReactComponent };